module.exports = __webpack_public_path__ + "img/responsive crc-01.6057bf18.jpg";